import {BitrixVue} from 'ui.vue'
import './resultBlockRow.js'

BitrixVue.component('ResultBlockCenter', {
  props: ['rowData'],
  template: `
		<div class="result-block__center">
			<ResultBlockRow v-for="(row, index) of rowData" :key="index" :row="row"/>
		</div>
`,
})
